var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "audit__log__box" }, [
    _vm.auditLogs.total > 0
      ? _c(
          "div",
          { staticClass: "audit-log-list d-flex", attrs: { role: "tablist" } },
          _vm._l(_vm.auditLogs.data, function(auditLog, index) {
            return _c(
              "b-card",
              {
                key: Math.random() * index,
                staticClass: "mb-4 item",
                attrs: { "no-body": "" }
              },
              [
                _c(
                  "b-card-header",
                  { attrs: { "header-tag": "header", role: "tab" } },
                  [
                    _c(
                      "b-button",
                      {
                        directives: [
                          {
                            name: "b-toggle",
                            rawName: "v-b-toggle",
                            value: "auditLog-" + auditLog.id,
                            expression: "'auditLog-' + auditLog.id"
                          }
                        ],
                        staticClass: "accordion-btn pointer-default",
                        attrs: { block: "", variant: "theme" }
                      },
                      [
                        _c(
                          "span",
                          { staticClass: "float-left audit__log__texts" },
                          [
                            _c("i", {
                              staticClass: "fa-fw",
                              class: _vm.logTypeIcon(auditLog.audit_log_type_id)
                            }),
                            _vm._v(" "),
                            _c("span", { staticClass: "fw-bold" }, [
                              _vm._v(_vm._s(auditLog.type.type))
                            ]),
                            _vm._v(" by\n            "),
                            _c("span", { staticClass: "fw-bold" }, [
                              _vm._v(_vm._s(auditLog.updating_user))
                            ])
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "span",
                          {
                            staticClass:
                              "float-left float-md-right audit__log__texts"
                          },
                          [
                            _vm._v(
                              "\n            " +
                                _vm._s(
                                  _vm._f("moment")(
                                    auditLog.created_at,
                                    "DD MMM, YYYY @ H:mm"
                                  )
                                ) +
                                "\n          "
                            )
                          ]
                        )
                      ]
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    attrs: {
                      id: "auditLog-" + auditLog.id,
                      visible: _vm.expandAll,
                      accordion: "auditLog-" + auditLog.id,
                      role: "tabpanel"
                    }
                  },
                  [
                    _c("b-card-body", [
                      auditLog.audit_log_type_id == 19
                        ? _c("p", { staticClass: "log-infos" }, [
                            _c("span", [
                              _c("div", { staticClass: "fw-bold" }, [
                                _vm._v("Profile")
                              ])
                            ])
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      (auditLog.deliverable_title ||
                        auditLog.task_title ||
                        auditLog.project_title) &&
                      auditLog.audit_log_type_id != 30 &&
                      auditLog.audit_log_type_id != 31
                        ? _c(
                            "p",
                            {
                              staticClass:
                                "d-flex no-gutters log-infos flex-wrap"
                            },
                            [
                              auditLog.deliverable_title
                                ? _c(
                                    "span",
                                    { staticClass: "col-12 col-md-6" },
                                    [
                                      _c("div", { staticClass: "fw-bold" }, [
                                        _vm._v("Deliverable")
                                      ]),
                                      _vm._v(_vm._s(auditLog.deliverable_title))
                                    ]
                                  )
                                : _vm._e(),
                              _c("br"),
                              _vm._v(" "),
                              auditLog.project_title
                                ? _c(
                                    "span",
                                    { staticClass: "col-12 col-md-6" },
                                    [
                                      _c("div", { staticClass: "fw-bold" }, [
                                        _vm._v("Project")
                                      ]),
                                      _vm._v(_vm._s(auditLog.project_title))
                                    ]
                                  )
                                : _vm._e(),
                              _c("br"),
                              _vm._v(" "),
                              auditLog.task_title
                                ? _c(
                                    "span",
                                    { staticClass: "col-12 col-md-6" },
                                    [
                                      _c("div", { staticClass: "fw-bold" }, [
                                        _vm._v("Task")
                                      ]),
                                      _vm._v(_vm._s(auditLog.task_title) + " ")
                                    ]
                                  )
                                : _vm._e()
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      auditLog.audit_log_type_id == 16
                        ? _c(
                            "p",
                            {
                              staticClass:
                                "d-flex no-gutters log-infos flex-wrap"
                            },
                            [
                              _c("span", { staticClass: "col-12 col-md-6" }, [
                                _c("div", { staticClass: "fw-bold" }, [
                                  _vm._v("Project")
                                ]),
                                _vm._v(
                                  _vm._s(
                                    _vm.parseJSON(auditLog.api_params).title
                                  )
                                )
                              ]),
                              _c("br")
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      auditLog.audit_log_type_id == 9 ||
                      auditLog.audit_log_type_id == 10
                        ? _c("p", { staticClass: "log-infos" }, [
                            _c("span", [
                              _c("div", { staticClass: "fw-bold" }, [
                                _vm._v("Coordinator")
                              ]),
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.parseJSON(auditLog.new_value)
                                      .first_name +
                                      " " +
                                      _vm.parseJSON(auditLog.new_value)
                                        .last_name
                                  )
                              )
                            ])
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      auditLog.audit_log_type_id == 4
                        ? _c("p", { staticClass: "log-infos" }, [
                            _c("span", [
                              _c("div", { staticClass: "fw-bold" }, [
                                _vm._v("Department")
                              ]),
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.parseJSON(auditLog.new_value).title
                                  )
                              )
                            ])
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      auditLog.audit_log_type_id == 6
                        ? _c("p", { staticClass: "log-infos" }, [
                            _c("span", [
                              _c("div", { staticClass: "fw-bold" }, [
                                _vm._v("Tag")
                              ]),
                              _vm._v(
                                " " +
                                  _vm._s(_vm.parseJSON(auditLog.new_value).tag)
                              )
                            ])
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      auditLog.audit_log_type_id == 8
                        ? _c("p", { staticClass: "log-infos" }, [
                            _c("span", [
                              _c("div", { staticClass: "fw-bold" }, [
                                _vm._v("Contact")
                              ]),
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.parseJSON(auditLog.new_value)
                                      .first_name +
                                      " " +
                                      _vm.parseJSON(auditLog.new_value)
                                        .last_name
                                  )
                              )
                            ])
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      auditLog.audit_log_type_id == 22
                        ? _c(
                            "p",
                            {
                              staticClass:
                                "d-flex no-gutters log-infos flex-wrap"
                            },
                            [
                              _c("span", { staticClass: "col-12 col-md-6" }, [
                                _c("div", { staticClass: "fw-bold" }, [
                                  _vm._v("Role")
                                ]),
                                _vm._v(
                                  _vm._s(
                                    _vm.parseJSON(auditLog.new_value).title
                                  )
                                )
                              ]),
                              _c("br")
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      auditLog.audit_log_type_id == 30
                        ? _c(
                            "p",
                            { staticClass: "d-flex no-gutters flex-wrap" },
                            [
                              _c(
                                "span",
                                { staticClass: "col-12 col-md-6 mb-4" },
                                [
                                  _c("div", { staticClass: "fw-bold" }, [
                                    _vm._v("Source Project")
                                  ]),
                                  _vm._v(
                                    _vm._s(
                                      _vm.parseJSON(auditLog.old_value)
                                        .source_project.title
                                    ) +
                                      " (#" +
                                      _vm._s(
                                        _vm.parseJSON(auditLog.old_value)
                                          .source_project.project_number
                                      ) +
                                      ")"
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "span",
                                { staticClass: "col-12 col-md-6 mb-4" },
                                [
                                  _c("div", { staticClass: "fw-bold" }, [
                                    _vm._v("Target Project")
                                  ]),
                                  _vm._v(
                                    _vm._s(
                                      _vm.parseJSON(auditLog.new_value)
                                        .merged_project.title
                                    ) +
                                      " (#" +
                                      _vm._s(
                                        _vm.parseJSON(auditLog.new_value)
                                          .merged_project.project_number
                                      ) +
                                      ")"
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _vm.parseJSON(auditLog.old_value).source_project
                                .start_date
                                ? _c(
                                    "span",
                                    { staticClass: "col-12 col-md-6 mb-4" },
                                    [
                                      _c("div", { staticClass: "fw-bold" }, [
                                        _vm._v("Source Start Date")
                                      ]),
                                      _vm._v(
                                        _vm._s(
                                          _vm._f("moment")(
                                            _vm.parseJSON(auditLog.old_value)
                                              .source_project.start_date,
                                            "DD MMM, YYYY"
                                          )
                                        )
                                      )
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.parseJSON(auditLog.new_value).merged_project
                                .start_date
                                ? _c(
                                    "span",
                                    { staticClass: "col-12 col-md-6 mb-4" },
                                    [
                                      _c("div", { staticClass: "fw-bold" }, [
                                        _vm._v("Target Start Date")
                                      ]),
                                      _vm._v(
                                        _vm._s(
                                          _vm._f("moment")(
                                            _vm.parseJSON(auditLog.new_value)
                                              .merged_project.start_date,
                                            "DD MMM, YYYY"
                                          )
                                        )
                                      )
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.parseJSON(auditLog.old_value).source_project
                                .due_date
                                ? _c(
                                    "span",
                                    { staticClass: "col-12 col-md-6 mb-4" },
                                    [
                                      _c("div", { staticClass: "fw-bold" }, [
                                        _vm._v("Source Due Date")
                                      ]),
                                      _vm._v(
                                        _vm._s(
                                          _vm._f("moment")(
                                            _vm.parseJSON(auditLog.old_value)
                                              .source_project.due_date,
                                            "DD MMM, YYYY"
                                          )
                                        )
                                      )
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.parseJSON(auditLog.new_value).merged_project
                                .due_date
                                ? _c(
                                    "span",
                                    { staticClass: "col-12 col-md-6 mb-4" },
                                    [
                                      _c("div", { staticClass: "fw-bold" }, [
                                        _vm._v("Target Due Date")
                                      ]),
                                      _vm._v(
                                        _vm._s(
                                          _vm._f("moment")(
                                            _vm.parseJSON(auditLog.new_value)
                                              .merged_project.due_date,
                                            "DD MMM, YYYY"
                                          )
                                        )
                                      )
                                    ]
                                  )
                                : _vm._e()
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      auditLog.audit_log_type_id == 31
                        ? _c(
                            "p",
                            { staticClass: "d-flex no-gutters flex-wrap" },
                            [
                              _c(
                                "span",
                                { staticClass: "col-12 col-md-6 mb-4" },
                                [
                                  _c("div", { staticClass: "fw-bold" }, [
                                    _vm._v("Source")
                                  ]),
                                  _vm._v(
                                    _vm._s(
                                      _vm.parseJSON(auditLog.old_value)
                                        .source_project.title
                                    )
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "span",
                                { staticClass: "col-12 col-md-6 mb-4" },
                                [
                                  _c("div", { staticClass: "fw-bold" }, [
                                    _vm._v("Duplicate")
                                  ]),
                                  _vm._v(
                                    _vm._s(
                                      _vm.parseJSON(auditLog.new_value)
                                        .duplicated_project.title
                                    )
                                  )
                                ]
                              )
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c("span", {
                        domProps: {
                          innerHTML: _vm._s(_vm.processAuditLog(auditLog))
                        }
                      })
                    ])
                  ],
                  1
                )
              ],
              1
            )
          }),
          1
        )
      : _c("div", [_vm._m(0)]),
    _vm._v(" "),
    _vm.auditLogs.total > 0
      ? _c(
          "div",
          { staticClass: "pagination-wrapper" },
          [
            _c("pagination", {
              attrs: { data: _vm.auditLogs, limit: 5 },
              on: { "pagination-change-page": _vm.onChangePage }
            })
          ],
          1
        )
      : _vm._e()
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "mb-5" }, [
      _c("h2", [_vm._v("Logs not found")])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }